// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Pc8D","questions":"styles_questions__3G9Iq","footer":"styles_footer__7JSJ1"};